'use strict';

/**
 * @ngdoc function
 * @name cimerFrontEndApp.service:Session
 * @description
 * #Session
 * Service of the cimerFrontEndApp
 */
angular.module('cimerFrontEndApp').service('Session',['$q','$http','ApiUrl','$window','$rootScope', function($q, $http, ApiUrl,$window,$rootScope) {

    var _apiUrl = ApiUrl.url('/User/');
    var _grantApi = ApiUrl.url('/Grant/');
    var _surveyApi = ApiUrl.url('/Survey/');

    var self = this;
    /*------------------------------------------------------------------
     * Passes a user's credentials to the session api for authentication
     * @param {String} user
     * @param {String} password
     * @return {Promise}
     */
    self.authenticate = function (user, password) {
        var deferred = $q.defer(),
            data = { Username: user, Password: password };

        $http.post(_apiUrl + 'Login', data).then(function (response) {
            // simple membership appears to return a 200 even if authentication failed
            if (angular.isObject(response) && response.data.IsAuthenticated) {
                var sessionObject = {
                    isAuthenticated: true,
                    role: response.data.Roles,
                    username: response.data.UserName,
                    relatedProjectIds: response.data.RelatedProjectIds,
                    isAdmin: response.data.Roles.indexOf("Administrator") !== -1,
                    isProjectAdmin: response.data.Roles.indexOf("ProjectAdmin") !== -1,
                    isCurriculaAdmin: response.data.Roles.indexOf("CurriculaAdmin") !== -1,
                    isDirector: response.data.Roles.indexOf("Director") !== -1,
                    isAlternate: response.data.Roles.indexOf("Alternate") !== -1,
                    isEventCreator: response.data.Roles.indexOf("EventCreator") !== -1,
                    surveyAdminProjectFilterID: null,
                    surveyAdminDivisionFilterID: null
                };
                self.saveSessionObject(sessionObject);
                $rootScope.$broadcast('login');
                deferred.resolve();
            }
            else {

                self.clearSessionObject();

                if (angular.isObject(response) && response.data) {

                    deferred.reject(response.data);
                    return;
                }
                
                deferred.reject(null);

            }
        }, function(err) {
            self.clearSessionObject();
            deferred.reject(err);
        });

        return deferred.promise;
    };

    /*-------------------------------------------------
     * Issues a POST request to the session api.
     * @return void
     */
    self.logout = function () {
        var promise = $http.post(_apiUrl+'Logout').then(function() {
            self.clearSessionObject();
        }, function() {
            self.clearSessionObject();
        });

        return promise;
    };

    /*-----------------------------------
    Triggers a forgot password request to the server
    *@param {String} email
    *@return Promise
    */
    self.forgotPassword = function(email) {
        var data = {
            email: email
        };
        var promise = $http.post(_apiUrl+'SendPasswordReset',data);

        return promise;
    };

    /*-----------------------------------
    Triggers a reset password request to the server
    *@param {String} token
    *@param {String} username
    *@param {String} password
    *@param {String} confirmPassword
    *@return Promise
    */
    self.resetPassword = function(token, username, password, confirmPassword) {
        var data= {
            token: token,
            username: username,
            newPassword:password,
            confirmNewPassword:confirmPassword
        };

        var promise = $http.post(_apiUrl+'ResetPasswordSubmit',data);

        return promise;

    };


    self.changePassword = function(password,newPassword,confirmPassword ) {
        var data = {
            currentPassword: password,
            newPassword: newPassword,
            confirmNewPassword: confirmPassword
        };

        var promise = $http.post(_apiUrl+'ChangePassword', data);

        return promise;
    };

    self.updateUser = function (data) {
        var promise = $http.post(_apiUrl+'UpdateUser',data);

        return promise;
    };

    self.createUser = function (data) {
        var promise = $http.post(_apiUrl + 'CreateUser', data);

        return promise;
    };

    self.userDetails = function () {
        var deferred = $q.defer();
        $http.get(_apiUrl+'CurrentUserDetails').then(function(response){
            self.user=response.data;
            deferred.resolve();
        }, function(err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };
    self.getRelatedProjectId = function () {
        var sessionObj = self.getSessionObject();
        if (!sessionObj.relatedProjectIds || sessionObj.relatedProjectIds.length !== 1) {
            return null;
        } else {
            return sessionObj.relatedProjectIds[0];
        }
    };
    // Check that user has director level privileges for the given grant
    self.userCanAccessGrant = function (grantID) {
        var deferred = $q.defer();
        $http.get(_grantApi + 'UserCanAccessGrantWithDirectorPrivileges/' + grantID).then(function (response) {
            deferred.resolve(response.data);
        });
        return deferred.promise;
    };
    // Check that user has applicable privileges for the given survey (admin for base surveys, director for custom)
    self.userCanAccessSurvey = function (surveyID) {
        var deferred = $q.defer();
        $http.get(_surveyApi + 'UserCanAccessSurvey/' + surveyID).then(function (response) {
            deferred.resolve(response.data);
        });
        return deferred.promise;
    };
    //save
    self.saveSessionObject = function (sessionObject) {
        if ($window.Storage) {
            $window.sessionStorage.setItem('session',angular.toJson(sessionObject));
        }
        else {
            self.session = sessionObject;
        }
    };
    self.getSessionObject = function() {
        if ($window.Storage) {
            return angular.fromJson($window.sessionStorage.getItem('session')) || {
                isAuthenticated: false,
                role: [],
                username: null,
                relatedProjectIds: [],
                isAdmin: false,
                isProjectAdmin: false,
                isDirector: false,
                isAlternate: false,
                isEventCreator: false,
                surveyAdminProjectFilterID: null,
                surveyAdminDivisionFilterID: null
            };
        }
        else {
            return self.session || {
                isAuthenticated: false,
                role: [],
                username: null,
                relatedProjectIds: [],
                isAdmin: false,
                isProjectAdmin: false,
                isDirector: false,
                isAlternate: false,
                isEventCreator: false,
                surveyAdminProjectFilterID: null,
                surveyAdminDivisionFilterID: null
            };
        }
    };
    self.clearSessionObject = function() {
        if ($window.Storage) {
            $window.sessionStorage.removeItem('session');
        }
        else {
            self.session = {
                isAuthenticated: false,
                role: [],
                username: null,
                relatedProjectIds: [],
                isAdmin: false,
                isProjectAdmin: false,
                isDirector: false,
                isAlternate: false,
                isEventCreator: false,
                surveyAdminProjectFilterID: null,
                surveyAdminDivisionFilterID: null
            };
        }
    };
    /*-----------------------------------------------
     * 'Public' Variables
     */
    //isAuthenticated (bool), role: (string[]), username: string
    self.session = {
        isAuthenticated: false,
        role: [],
        username: null,
        relatedProjectIds: [],
        isAdmin: false,
        isProjectAdmin: false,
        isDirector: false,
        isAlternate: false,
        isEventCreator: false,
        surveyAdminProjectFilterID: null,
        surveyAdminDivisionFilterID: null
    };
    self.user = null;  //used in userDetails
    
    
    return self; 


}]);

/**
 * @ngdoc function
 * @name cimerFrontEndApp.service:ApiUrl
 * @description
 * #ApiUrl
 * Builds a URL to an API endpoint
 * @param {String} url
 * @return {String} Properly constructed API url
 */
angular.module('cimerFrontEndApp').service('ApiUrl', ['$window', function ApiUrl($window) {
  return {

    url: function (url) {
      if (url.indexOf('/') !== 0) {
        url = '/' + url;
      }

      return '/api' + url;
    }
  };
}]);
